<div class="d-flex w-100" [class.flex-wrap]="wrapItems" [hidden]="theme !== 'sementic'">
  <span class="first-item" phx-tooltip tooltipOnTruncate [phxContent]="firstItem">{{ firstItem }}</span>
  <span class="counter" [hidden]="!subList.length" phx-tooltip [phxContent]="sementicTemplate" [phxPlacement]="position">
    +{{ subList.length }} <span *ngIf="label">{{ subList.length | i18nPlural : labelMapping }}</span>
  </span>
</div>

<a
  [hidden]="theme !== 'ant'"
  class="d-flex w-100"
  [class.flex-wrap]="wrapItems"
  phx-tooltip
  [phxContent]="subList.length ? listContent : first"
  [phxPlacement]="position"
  (click)="clicked()"
>
  <span class="red-50-imp first-item">
    {{ firstItem }}
  </span>
  <nz-tag [hidden]="!subList.length" [nzColor]="'red'" class="tag-count">
    +{{ subList.length }} <span *ngIf="label">{{ subList.length | i18nPlural : labelMapping }}</span>
  </nz-tag>
</a>

<ng-container *ngIf="theme === 'new-groups'">
  <a
    class="d-flex"
    [class.flex-wrap]="wrapItems"
    [ngClass]="className"
    phx-tooltip
    [phxContent]="subList.length && fullListContent"
    [phxPlacement]="position"
    (click)="clicked()"
  >
    <span 
      *ngIf="subList.length" 
      class="new-group-first-item"
      phx-underline
      [phxHideUnderline]="!isLabelDotted"
      [ngClass]="!isLabelDotted ? 'groups-text' : null"
      >
      {{ list?.length }} <ng-container>{{pluralText}}</ng-container>
    </span>
  </a>
  <div *ngIf="!subList.length" phx-tooltip tooltipOnTruncate class="new-group-first-item ellipsis cursor-default" [ngClass]="className" [phxContent]="firstItem">
    {{ firstItem }}
  </div>
</ng-container>

<ng-template #fullListContent>
  <div>
    <div *ngFor="let item of maxedList">{{ item }}</div>
  </div>
</ng-template>

<ng-template #listContent>
  <div>
    <div *ngFor="let item of subList">{{ item }}</div>
  </div>
</ng-template>

<ng-template #first>
  <ng-container>{{ firstItem }}</ng-container>
</ng-template>

<ng-template #sementicTemplate>
  <div data-e2e="item-row" *ngFor="let item of subList | slice : 0 : maxItems">
    {{ item }}
  </div>
  <div *ngIf="subList?.length > maxItems" data-e2e="item-row">
    +{{ subList?.length - maxItems }} more
  </div>
</ng-template>